import DataBinder from "../DataBinder.js";
import SwapPage from "../SwapPage.js";
import Items from "../Items.js";


export default class IAPMenuController {

  constructor(app) {
    this.app = app;
    this.items = app.items;
    this.PageId = "IAPMenu";
    this.loaded = false;
    this.IAP = app.IAP;
  }

  async show(path, model) {
    if (!this.loaded) {
      this.loaded = true;
      // //IAP
      // let iapProductIds = this.items.allItems.filter(i => i.type === "IAP").map(i => i.id);
      // this.IAP.init(iapProductIds).catch(e => console.log("IAP.init() failed", e))
      //   .then(() => {
      //     const data = this.loadProducts();
      //     this.populate(data);
      //   });
    }
    model = await this.loadProducts();

    const dataBinder = new DataBinder();
    dataBinder.populate(this.PageId, model);

    const swapPage = new SwapPage();
    swapPage.swapPage(this.PageId);
  }
  populate(model) {
    const dataBinder = new DataBinder();
    dataBinder.populate(this.PageId, model);
  }
  async loadProducts() {
    const app = this.app;
    const userdata = app.userdata;
    const advertisement = app.advertisement;
    const allItems = this.items.allItems;
    const IAP = app.IAP;
    
    let coins = userdata.coins || 0;
    let removeAds = userdata.removeAds;
    let fullVersion = userdata.fullVersion;
    let catalog = await IAP.getCatalog() || [];

    let items = allItems.filter((i) => {
      if (i.type !== "IAP") return false;
      let product = catalog.find(j => j.productId === i.id);
      if (!product) return false;
      if (!product.canPurchase) return false;
      //mark remove ads as owned if user has full version
      //note: can be removed later 4/1/2024
      if(i.id ==="com.jdsoftwarellc.speed.removeads" && fullVersion){
        i.owned = true;
      }
      return true;
    });
    let itemsModel = items.map((i) => {
      let product = catalog.find(j => j.productId === i.id);
      if (!product) return false;
      return {
        id: i.id,
        name: product.name || i.name,
        icon: product.icon || i.icon,
        title: product.title || i.title,
        description: product.description || i.description,
        price: !product.owned ? product.price : "Owned",
        owned: product.owned
      };
    });
    const showRewardAd = !fullVersion && !advertisement.removeAds;
    let model = {
      coins: coins,
      items: itemsModel,
      fullVersion: fullVersion,
      showRewardAd: showRewardAd
    }
    return model;
  }
}